/* eslint-disable quote-props */
export default {
  /* Entities */
  'task': 'Taak',
  'tasks': 'Taken',
  'deal': 'Deal',
  'deals': 'Deals',
  'appointment': 'Afspraak',
  'appointments': 'Afspraken',
  'ticket': 'Ticket',
  'tickets': 'Tickets',
  'company': 'Bedrijf',
  'companies': 'Bedrijven',
  'contact': 'Contact',
  'contacts': 'Contacten',
  'contact-moment': 'Contactmoment | Contactmomenten',
  'contact-moments': 'Contactmomenten',
  'employee': 'Medewerker',
  'employees': 'Medewerkers',
  'view-entity': '{entity} weergeven',
  'error-loading-entity': 'Fout bij het laden van {entity}. Probeer het opnieuw.',
  'all-entities': 'Alle {entity}',
  'my-entities': 'Mijn {entity}',
  'create': 'aanmaken',

  /* Authentication */
  'forgot-password': 'Wachtwoord vergeten',
  'or': 'of',
  'no-account': 'nog geen account',
  'password': 'Wachtwoord',
  'login': 'Inloggen',
  'reset-password': 'Opnieuw instellen',
  'login-anyway': 'Toch inloggen',
  'already-account': 'Heeft u al een account',
  'register': 'Registreren',
  'welcome-bird': 'Hoi, leuk je te leren kennen {name}! Ik ben je nieuwe persoonlijke assistent!',
  'agree-terms': 'Ik ga akkoord met de {0}.',
  'terms': 'algemene voorwaarden',
  'terms-filename': 'algemene-voorwaarden.pdf',
  'terms-error': 'U dient akkoord te gaan met de algemene voorwaarden om gebruik te maken van CRM Bird.',
  'logout': 'Uitloggen',

  /* Fields */
  'email': 'E-mail',
  'first-name': 'Voornaam',
  'last-name': 'Achternaam',
  'name': 'Naam',
  'company-name': 'Bedrijfsnaam',
  'phone': 'Telefoon',
  'website': 'Website',
  'address': 'Adres',
  'zipcode': 'Postcode',
  'street': 'Straat',
  'housenumber': 'Huisnummer',
  'state': 'Provincie',
  'city': 'Plaats',
  'contact-info': 'Contactgegevens',
  'company-info': 'Bedrijfsgegevens',
  'coc-number': 'KvK-nummer',
  'vat-number': 'Btw-nummer',

  /* Dashboard */
  'date-today': 'Het is {date}.',
  'date-today-format': 'dddd D MMMM',
  'appointment-date': '{date} van {start} tot {end}',
  'date-format': 'DD MMMM YYYY',
  'time-format': 'H:mm',
  'none': 'Geen',
  'created-at': 'Aangemaakt',
  'communication': 'Communicatie',
  'added-files': 'Toegevoegde bestanden',
  'extra-info': 'Extra informatie',
  'no-messages': 'Er zijn geen berichten.',
  'no-internal-messages': 'Er zijn geen interne berichten.',
  'calendar': 'Agenda',
  'view-agenda': 'Agenda weergeven',
  'unplanned': 'Nog niet ingepland',
  'all-day': 'Hele dag',
  'stage': 'Stadium',
  'last-activity': 'Laatste activiteit',
  'search-administration': 'Zoeken in administratie',
  'all-tasks-done': 'Je hebt geen openstaande taken',
  'all-tickets-done': 'Je hebt geen openstaande tickets',
  'no-appointments': 'Je hebt geen afspraken die je aandacht vereisen',
  'no-deals': 'Je hebt geen deals die je aandacht vereisen',
  'enthousiastic': ['nice', 'top', 'gaaf', 'goed gedaan', 'super'],

  /* Errors */
  'error-title': 'Oh no, er is een fout opgetreden!',
  'error-text': 'Er is een fout opgetreden, probeer het opnieuw.',
  'no-entities-found': 'Geen {entity} gevonden',

  /* Companies */
  'companies-tagline': [
    'Wie heb je nodig?', 
    'Naar wie ben je op zoek?'
  ],
  'bird-company-exists': [
    'Het bedrijf {company} bestaat al in je administratie! Weet je zeker dat je deze aan wilt maken?',
    'Ik heb het bedrijf {company} al gevonden in je administratie! Weet je zeker dat je deze aan wilt maken?',
    'Dit bedrijf bestaat al in je administratie! Weet je zeker dat je deze aan wilt maken?',
  ],
  'bird-coc': [
    'Ik ben even naar het handelsregister gevlogen en ik heb {company} gevonden en de gegevens voor je ingevuld!',
    'Ik heb {company} gevonden in het handelsregister en alvast de gegevens voor je ingevuld!',
  ],
  'company-create-tagline': 'Een nieuwe klant!',
  'last-contact': 'Laatste contact',
  'data': 'Gegevens',
  'address-firstline': '{street} {number}',
  'address-secondline': '{zipcode} {city}',
  'address-thirdline': '{state}, {country}',
  'address-short': '{street} {number}, {zipcode} {city}',
  'company-contacts': 'Contactpersoon | Contactpersonen',
  'no-contacts': 'Er zijn geen contactpersonen toegewezen aan dit bedrijf.',

  /* Contacts */
  'contacts-tagline': ['Wie heb je nodig?', 'Naar wie ben je op zoek?'],
  'contact-companies': 'Bedrijf | Bedrijven',
  'no-companies': 'Er zijn geen bedrijven gekoppeld aan dit contact.',
  'email-address': 'Emailadres | E-mailadressen',
  'phone-number': 'Telefoonnummer | Telefoonnummers',

  /* Greetings */
  'goodmorning': 'Goedemorgen',
  'goodafternoon': 'Goedemiddag',
  'goodevening': 'Goedenavond',
  'informal-greeting': ['Hoi', 'Hallo', 'Hey', 'Hee'],
};



// WEBPACK FOOTER //
// ./src/lang/nl.js